import { useMessage } from "@/common/messages";
import { ServerEvent } from "@/common/notification";
import { useAuth } from "@/hooks/authentication";
import { notificationListener } from "@/hooks/notification";
import { useIntl } from "react-intl";

export const useAccountManager = () => {
	const authentication = useAuth();
	const { show: showMessage } = useMessage();
	const intl = useIntl();

	notificationListener(ServerEvent.SupervisedAgentSignedOut, () => {
		authentication.signOut();

		showMessage("global", {
			intent: "warning",
			text: intl.formatMessage({
				id: "Account.SignOutBySupervisor",
			}),
			duration: 86400000, //24h
		});
	});
};
